import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Clock, HeartCrack } from 'lucide-react';
export function EmotionalStory() {
  return <section className="py-20 bg-cream-dark" data-id="element-12">
      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center" data-id="element-13">
        <FadeIn data-id="element-14">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-earth-light mb-8" data-id="element-15">
            <Clock className="w-8 h-8 text-earth-darker" data-id="element-16" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-earth-darker" data-id="element-17">
            Son las 2:42 AM.
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-18">
          <p className="text-lg md:text-xl text-earth-dark leading-relaxed mb-6" data-id="element-19">
            Tus brazos tiemblan de cansancio y el llanto de tu bebé se clava en
            tus oídos como una aguja. Has intentado todo: mecerlo, cambiarlo,
            darle gotas, cantarle... pero nada funciona.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-20">
          <p className="text-lg md:text-xl text-earth-dark leading-relaxed mb-12" data-id="element-21">
            Sientes esa presión en el pecho, esa mezcla de culpa e impotencia al
            ver a tu pequeño sufriendo, con la cara roja y las piernas
            encogidas.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-22">
          <div className="bg-cream p-8 md:p-10 rounded-2xl shadow-sm border border-earth-light/50 relative" data-id="element-23">
            <HeartCrack className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 text-accent bg-cream rounded-full p-1" data-id="element-24" />
            <p className="text-lg font-medium text-earth-darker italic" data-id="element-25">
              El problema no es que seas un "mal padre" o una "mala madre". El
              problema es que te han vendido teorías, cuando lo que necesitas es
              fisiología aplicada.
            </p>
            <p className="mt-4 text-earth-dark" data-id="element-26">
              El sistema digestivo de tu bebé es inmaduro y su sistema nervioso
              está en cortocircuito. No necesita más mimos; necesita un reseteo
              físico.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}